import React, { useEffect, useState } from 'react';

import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import PositionedSnackbar from "../../components/general/PositionedSnackbar";
import { useDispatch } from 'react-redux'
import Config from '../../config'
import GeneralStyles from '../GeneralStyles.module.scss'
import CustomLoaderSpinner from "../../components/general/CustomLoaderSpinner";
import PageHeader from "../../components/general/PageHeader";
import {Accordion, AccordionDetails, AccordionSummary} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Colors from "../../config/colors";
import Styles from './styles/Settings.module.scss'
import CustomTextFieldNew from "../../components/general/CustomTextFieldNew";
import CustomButtonContained from "../../components/general/CustomButtonContained";
import {getAssumptionsSettings, updateSettingsData, updateSettingsUpdatedStatus} from '../../redux/slices/settingsSlice'
import {API_CALL_STATUS} from "../../metadata/enums";
import Constants from "../../config/constants";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CustomTextFieldPlain from "../../components/general/CustomTextFieldPlain";
import {Edit} from "@mui/icons-material"
import Helpers from "../../utils/helpers";

const EXPANDABLE_VALUES = [
	'mortgage',
	'financial',
	'pricing',
	'underwriting',
	'loanTiers'
]




export default function Settings() {
	let dispatch = useDispatch()
	let navigate = useNavigate()

	const user = useSelector(state => {
		// console.log('inside home selector', state.user)
		return state.user
	})
	const token = useSelector(state => state.auth.token)
	const settingsState = useSelector(state => state.settings)

	const [assumptions, setAssumptions] = useState(null)
	const [loading, setLoading] = useState(false)
	const [showError, setShowError] = useState(false)
	const [errorMessage, setErrorMessage] = useState('')
	const [successMessage, setSuccessMessage] = useState('')
	const [showSuccess, setShowSuccess] = useState(false)
	const [expanded, setExpanded] = useState(EXPANDABLE_VALUES)
	const [apr, setApr] = useState('')
	const [loanToCost, setLoanToCost] = useState('')
	const [term, setTerm] = useState('')
	const [vacancy, setVacancy] = useState('')
	const [propertyTaxes, setPropertyTaxes] = useState('')
	const [managementFee, setManagementFee] = useState('')
	const [leaseFee, setLeaseFee] = useState('')
	const [insurance, setInsurance] = useState('')
	const [maintenance, setMaintenance] = useState('')
	const [capEx, setCapEx] = useState('')
	const [misc, setMisc] = useState('')
	const [turnReserves, setTurnReserves] = useState('')
	const [sofr, setSofr] = useState('')
	const [treasury, setTreasury] = useState('')
	const [loanCost, setLoanCost] = useState('')
	const [margin, setMargin] = useState('')
	const [loanFeeFixed, setLoanFeeFixed] = useState('')
	const [loanFeePercent, setLoanFeePercent] = useState('')
	const [dscr, setDscr] = useState('')
	const [cltv, setCltv] = useState('')
	const [cellSelected, setCellSelected] = useState(null)
	const [capRate, setCapRate] = useState('')
	const [dscrTiers, setDscrTiers] = useState([])
	const [rates, setRates] = useState({
	  6: {benchmark: '', spread: ''},
		9: {benchmark: '', spread: ''},
		12: {benchmark: '', spread: ''},
		18: {benchmark: '', spread: ''}
})


	useEffect(() => {
		if(settingsState.status === API_CALL_STATUS.LOADING) {
			setLoading(true)
		} else if(settingsState.status === API_CALL_STATUS.FAILED) {
			setErrorMessage('Error when getting settings data. Please contact support if the problem persists.')
			setShowError(true)
		} else {
			setAssumptions(getAssumptionsSettings(settingsState))
			setLoading(false)

			if(settingsState.updated_settings) {
				setSuccessMessage('Settings updated successfully')
				setShowSuccess(true)
				dispatch(updateSettingsUpdatedStatus(false))
			}
		}
	},[settingsState])

	useEffect(() => {
		if(assumptions && assumptions._id === 'assumptions') {
			if(assumptions?.rates)
				setRates(assumptions.rates || {})
			let {mortgage, financials, pricing, underwriting} = assumptions
			if(mortgage) {
				setApr(Number(mortgage.apr).toFixed(2))
				setLoanToCost(Number(mortgage.loan_to_cost).toFixed(2))
				setTerm(mortgage.term)
			}

			if(financials) {
				setVacancy(Number(financials.vacancy_factor).toFixed(2));
				setPropertyTaxes(Number(financials.property_taxes).toFixed(2));
				setManagementFee(Number(financials.management_fees).toFixed(2));
				setLeaseFee(Number(financials.leasing_fees).toFixed(2));
				setInsurance(Number(financials.property_insurance).toFixed(2));
				setMaintenance(Number(financials.repairs_maintenance).toFixed(2));
				setCapEx(Number(financials.cap_ex_reserve).toFixed(2));
				setMisc(Number(financials.other).toFixed(2));
				setTurnReserves(Number(financials.turn_reserves).toFixed(2));
			}

			if(pricing) {
				setSofr(Number(pricing.sofr).toFixed(2));
				setTreasury(Number(pricing.treasury).toFixed(2));
				setLoanCost(Number(pricing.cost).toFixed(2));
				setMargin(Number(pricing.margin).toFixed(2));
				setLoanFeeFixed(Number(pricing.loan_fee?.fixed).toFixed(2));
				setLoanFeePercent(Number(pricing.loan_fee?.percent).toFixed(2));
			}

			if(underwriting) {
				setDscr(Number(underwriting.min_dscr).toFixed(2));
				setCltv(Number(underwriting.max_cltv).toFixed(2));
				setCapRate(Number(underwriting.cap_rate).toFixed(2));
				setDscrTiers(underwriting.dscr_tiers || [])
      }
		}
	},[assumptions])

	// useEffect(() => {
	// 	let E53 = 14873/12
	// 	let K7 = 6.73/100
	// 	let result = (-E53 * (1 - Math.pow(1 + K7 / 12, 6))) / (K7 / 12);
	// }, []);

	const handleExpandChange = (id) => {
		if(expanded.includes(id)) {
			//close it
			let temp = expanded.filter(item => item !== id)
			setExpanded(temp)
		} else {
			//add it
			let temp = [...expanded, id]
			setExpanded(temp)
		}
	}

	const onSaveMortgageValuesClicked = () => {
		if (apr === '' || isNaN(apr) || Number(apr) < 0 || Number(apr) > 100) {
			setErrorMessage('Please enter valid Annual Percentage Rate (APR) between 0 and 100')
			setShowError(true)
			return
    }

		if(loanToCost === '' || isNaN(loanToCost) || Number(loanToCost) < 0 || Number(loanToCost) > 100) {
			setErrorMessage('Please enter valid Loan to Cost value between 0 and 100')
			setShowError(true)
			return
		}

		if(term === '' || isNaN(term) || Number(term) < 0) {
			setErrorMessage('Please enter valid Loan Term value')
      setShowError(true)
      return
		}

    let data = Object.assign({}, assumptions, {
			mortgage: {
				apr: Number(apr) || 0,
				loan_to_cost: Number(loanToCost) || 0,
				term: Number(term) || 0
			}
		})

		dispatch(updateSettingsData({data, token}))
	}

	const onSaveUnderwritingValuesClicked = () => {
		if(dscr === '' || isNaN(dscr) || Number(dscr) < 0 || Number(dscr) > 100) {
			setErrorMessage('Please enter valid DSCR value between 0 and 100')
      setShowError(true)
      return
		}

		if(cltv === '' || isNaN(cltv) || Number(cltv) < 0 || Number(cltv) > 100) {
			setErrorMessage('Please enter valid CLTV value between 0 and 100')
      setShowError(true)
      return
		}

		if(capRate === '' || isNaN(capRate) || Number(capRate) < 0 || Number(capRate) > 100) {
      setErrorMessage('Please enter valid Cap Rate value between 0 and 100')
      setShowError(true)
      return
    }

		let dscrArray = []
		let flag = false
		dscrTiers.every((tier) => {
			if(tier === '' || isNaN(tier) || Number(tier) < 0 || Number(tier) > 10) {
				flag = true
        return false
			}
			dscrArray.push(Number(tier))
			return true
		})

		if(flag) {
			setErrorMessage('Please enter valid DSCR value between 1 and 10 for each tier')
			setShowError(true)
			return
		}

		let data = Object.assign({}, assumptions, {
			underwriting: {
        min_dscr: Number(dscr) || 0,
        max_cltv: Number(cltv) || 0,
				cap_rate: Number(capRate) || 0,
				dscr_tiers: dscrArray
      }
		})

		dispatch(updateSettingsData({data, token}))


	}

	const onSaveFinancialsClicked = () => {
		if(managementFee === '' || isNaN(managementFee) || Number(managementFee) < 0 || Number(managementFee) > 100) {
      setErrorMessage('Please enter valid Management Fee value')
      setShowError(true)
      return
    }

    if(leaseFee === '' || isNaN(leaseFee) || Number(leaseFee) < 0 || Number(leaseFee) > 100) {
      setErrorMessage('Please enter valid Lease Fee value')
      setShowError(true)
      return
    }

    if(insurance === '' || isNaN(insurance) || Number(insurance) < 0 || Number(insurance) > 100) {
      setErrorMessage('Please enter valid Insurance value')
      setShowError(true)
      return
    }

    if(maintenance === '' || isNaN(maintenance) || Number(maintenance) < 0 || Number(maintenance) > 100) {
			setErrorMessage('Please enter valid Maintenance value')
			setShowError(true)
			return
		}
		if(capEx === '' || isNaN(capEx) || Number(capEx) < 0 || Number(capEx) > 100) {
      setErrorMessage('Please enter valid Capital Expenditure value')
      setShowError(true)
      return
    }

		if(misc === '' || isNaN(misc) || Number(misc) < 0 || Number(misc) > 100) {
			setErrorMessage('Please enter valid Miscellaneous value')
			setShowError(true)
			return
		}

		if(turnReserves === '' || isNaN(turnReserves) || Number(turnReserves) < 0 || Number(turnReserves) > 100) {
			setErrorMessage('Please enter valid Turn Reserves value')
      setShowError(true)
      return
		}

		if(vacancy === '' || isNaN(vacancy) || Number(vacancy) < 0 || Number(vacancy) > 100) {
			setErrorMessage('Please enter valid Vacancy value')
      setShowError(true)
      return
		}

		if(propertyTaxes === '' || isNaN(propertyTaxes) || Number(propertyTaxes) < 0 || Number(propertyTaxes) > 100) {
			setErrorMessage('Please enter valid Property Taxes value')
      setShowError(true)
      return
		}

		let data = Object.assign({}, assumptions, {
			financials: {
        management_fees: Number(managementFee) || 0,
        leasing_fees: Number(leaseFee) || 0,
        property_insurance: Number(insurance) || 0,
        repairs_maintenance: Number(maintenance) || 0,
        cap_ex_reserve: Number(capEx) || 0,
        other: Number(misc) || 0,
        turn_reserves: Number(turnReserves) || 0,
        vacancy_factor: Number(vacancy) || 0,
        property_taxes: Number(propertyTaxes) || 0
      }
		})

		dispatch(updateSettingsData({data, token}))

	}

	const onSaveLoanRatesClicked = () => {
		// if(cellSelected !== null) {
		// 	setErrorMessage('Please edit the cell and press enter before clicking on save!')
		// 	setShowError(true)
		// 	return
		// }
		let toSaveRates = {
			6: {benchmark: Number(rates[6].benchmark), spread: Number(rates[6].spread)},
			9: {benchmark: Number(rates[9].benchmark), spread: Number(rates[9].spread)},
			12: {benchmark: Number(rates[12].benchmark), spread: Number(rates[12].spread)},
			18: {benchmark: Number(rates[18].benchmark), spread: Number(rates[18].spread)},
		}

		let data = Object.assign({}, assumptions, {rates: toSaveRates})

		dispatch(updateSettingsData({data, token}))
	}

	const onSavePricingAssumptionsClicked = () => {
		if(loanCost === '' || isNaN(loanCost) || Number(loanCost) < 0 || Number(loanCost) > 100) {
			setErrorMessage('Please enter valid Loan Cost value')
      setShowError(true)
      return
		}

		if(sofr === '' || isNaN(sofr) || Number(sofr) < 0 || Number(sofr) > 100) {
			setErrorMessage('Please enter valid SOFR value')
      setShowError(true)
      return
		}

		if(treasury === '' || isNaN(treasury) || Number(treasury) < 0 || Number(treasury) > 100) {
			setErrorMessage('Please enter valid Treasury value')
      setShowError(true)
      return
		}

		if(margin === '' || isNaN(margin) || Number(margin) < 0 || Number(margin) > 100) {
			setErrorMessage('Please enter valid Margin value')
      setShowError(true)
      return
		}

		if(loanFeeFixed === '' || isNaN(loanFeeFixed) || Number(loanFeeFixed) < 0) {
			setErrorMessage('Please enter valid loan fee fixed value')
      setShowError(true)
      return
		}

		if(loanFeePercent === '' || isNaN(loanFeePercent) || Number(loanFeePercent) < 0) {
			setErrorMessage('Please enter valid loan fee percent value')
			setShowError(true)
			return
		}

		let data = Object.assign({}, assumptions, {
			pricing: {
        cost: Number(loanCost) || 0,
        sofr: Number(sofr) || 0,
        treasury: Number(treasury) || 0,
        margin: Number(margin) || 0,
				loan_fee: {
					fixed: Number(loanFeeFixed) || 0,
          percent: Number(loanFeePercent) || 0
				}
      }
		})

		dispatch(updateSettingsData({data, token}))
	}

	const renderPricingAssumptions = () => {
		return (
			<Accordion
				sx={{boxShadow: '0px 4px 15px 0px #00000066', border: '1px solid #E7E7E7', marginTop: 2}}
        expanded={expanded.includes(EXPANDABLE_VALUES[2])}
        onChange={() => handleExpandChange(EXPANDABLE_VALUES[2])}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{color: Colors.primaryTextColor}}/>}
          aria-controls="pricing-content"
          id="pricing-header"
          sx={{height: 40}}
        >
          <p className={GeneralStyles.darkText} style={{fontWeight: 'bold'}}>Pricing Assumptions</p>
        </AccordionSummary>
        <AccordionDetails>
          <div className={Styles.accordionDetails}>
						<CustomTextFieldNew
							width={'30%'}
							label={"SOFR (%)"}
							placeholder={'Enter SOFR Value'}
							value={sofr}
							onChange={(text) => {
								if (Helpers.checkIfNumber(text)) {
									setSofr(text)
								}
							}}
						/>

						<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
							<CustomTextFieldNew
								marginTop={10}
								width={'30%'}
								label={"1 Year Treasury (%)"}
								placeholder={'Enter 1 Year Treasury Value'}
								value={treasury}
								onChange={(text) => {
									if (Helpers.checkIfNumber(text)) {
										setTreasury(text)
									}
								}}
							/>

							<a style={{marginLeft: 20}} href={"https://www.cnbc.com/bonds/"} target="_blank" rel="noopener noreferrer">Treasure Rates Reference</a>
						</div>

						<CustomTextFieldNew
							marginTop={10}
							width={'30%'}
							label={"Cost (%)"}
							placeholder={'Enter Cost'}
							value={loanCost}
							onChange={(text) => {
								if (Helpers.checkIfNumber(text)) {
									setLoanCost(text)
								}
							}}
						/>

						<CustomTextFieldNew
							marginTop={10}
							width={'30%'}
							label={"Desired Margin (%)"}
							placeholder={'Enter Desired Margin'}
							value={margin}
							onChange={(text) => {
								if (Helpers.checkIfNumber(text)) {
									setMargin(text)
								}
							}}
						/>

	          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10}}>
		          <CustomTextFieldNew
			          width={'14%'}
			          label={"Loan Points/Fee ($)"}
			          placeholder={'Enter Loan Points Fixed Value'}
			          value={loanFeeFixed}
			          onChange={(text) => {
				          if (Helpers.checkIfNumber(text)) {
					          setLoanFeeFixed(text)
				          }
			          }}
		          />

		          <CustomTextFieldNew
			          marginLeft={'1%'}
			          width={'14%'}
			          label={"Loan Points/Fee (%)"}
			          placeholder={'Enter Loan Points Percentage'}
			          value={loanFeePercent}
			          onChange={(text) => {
				          if (Helpers.checkIfNumber(text)) {
					          setLoanFeePercent(text)
				          }
			          }}
		          />
	          </div>

						<div style={{width: '100%', position: 'relative', height: 50}}>
							<CustomButtonContained
								style={{height: 36, position: 'absolute', bottom: 0, right: 0}}
								text={`\u2713 Save Changes`}
								onClick={onSavePricingAssumptionsClicked}
							/>
						</div>



					</div>
				</AccordionDetails>
			</Accordion>
		)
	}

	const renderError = (message) => {
		setErrorMessage(message)
    setShowError(true)
	}

	const onRatesEnterPressed = (index1, index2) => {
		if(isNaN(rates[index1][index2])) {
			renderError('Please enter a valid number')
		} else {
			let temp = JSON.parse(JSON.stringify(rates))
			temp[index1][index2] = Number(rates[index1][index2])
			setRates(temp)
			setCellSelected(null)
		}
	}

	const onRatesChanged = (index1, index2, value) => {
		let temp = JSON.parse(JSON.stringify(rates))
		temp[index1][index2] = value
		setRates(temp)
	}

	const renderLoanTiers = () => {
		let tier1 = {
			c1: isNaN(rates['6']['benchmark']) || isNaN(rates['6']['spread']) ? '' : (Number(rates['6']['benchmark']) + Number(rates['6']['spread'])).toFixed(2),
			c2: isNaN(rates['9']['benchmark']) || isNaN(rates['9']['spread']) ? '' : (Number(rates['9']['benchmark']) + Number(rates['9']['spread'])).toFixed(2),
			c3: isNaN(rates['12']['benchmark']) || isNaN(rates['12']['spread']) ? '' : (Number(rates['12']['benchmark']) + Number(rates['12']['spread'])).toFixed(2),
			c4: isNaN(rates['18']['benchmark']) || isNaN(rates['18']['spread']) ? '' : (Number(rates['18']['benchmark']) + Number(rates['18']['spread'])).toFixed(2),
		}
		let tier2 = {
				c1: isNaN(rates['6']['benchmark']) || isNaN(rates['6']['spread']) ? '' : (Number(rates['6']['benchmark']) + Number(rates['6']['spread']) + 1).toFixed(2),
				c2: isNaN(rates['9']['benchmark']) || isNaN(rates['9']['spread']) ? '' : (Number(rates['9']['benchmark']) + Number(rates['9']['spread']) + 1).toFixed(2),
				c3: isNaN(rates['12']['benchmark']) || isNaN(rates['12']['spread']) ? '' : (Number(rates['12']['benchmark']) + Number(rates['12']['spread']) + 1).toFixed(2),
				c4: isNaN(rates['18']['benchmark']) || isNaN(rates['18']['spread']) ? '' : (Number(rates['18']['benchmark']) + Number(rates['18']['spread']) + 1).toFixed(2),
		}
		let tier3 = {
				c1: isNaN(rates['6']['benchmark']) || isNaN(rates['6']['spread']) ? '' : (Number(rates['6']['benchmark']) + Number(rates['6']['spread']) + 2).toFixed(2),
				c2: isNaN(rates['9']['benchmark']) || isNaN(rates['9']['spread']) ? '' : (Number(rates['9']['benchmark']) + Number(rates['9']['spread']) + 2).toFixed(2),
				c3: isNaN(rates['12']['benchmark']) || isNaN(rates['12']['spread']) ? '' : (Number(rates['12']['benchmark']) + Number(rates['12']['spread']) + 2).toFixed(2),
				c4: isNaN(rates['18']['benchmark']) || isNaN(rates['18']['spread']) ? '' : (Number(rates['18']['benchmark']) + Number(rates['18']['spread']) + 2).toFixed(2),
		}
		return (
			<Accordion
				sx={{boxShadow: '0px 4px 15px 0px #00000066', border: '1px solid #E7E7E7', marginTop: 2}}
				expanded={expanded.includes(EXPANDABLE_VALUES[4])}
				onChange={() => handleExpandChange(EXPANDABLE_VALUES[4])}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon style={{color: Colors.primaryTextColor}}/>}
					aria-controls="underwriting-content"
					id="underwriting-header"
					sx={{height: 40}}
				>
					<p className={GeneralStyles.darkText} style={{fontWeight: 'bold'}}>Loan Tiers</p>
				</AccordionSummary>
				<AccordionDetails>
					<Table sx={{ width: '80%'}} aria-label="simple table">
						<TableHead>
							<TableRow>
								<TableCell>Term</TableCell>
								<TableCell >6 Months</TableCell>
								<TableCell >9 Months</TableCell>
								<TableCell >12 Months</TableCell>
								<TableCell >18 Months</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							<TableRow key={1}>
                <TableCell component="th" scope="row" sx={{width: '20%'}}>Benchmark / Index</TableCell>
                <TableCell sx={{width: '20%'}}>
									{
										cellSelected === 'r1c1' ?
											<CustomTextFieldPlain
												value={rates['6']['benchmark']}
												enterPressed={() => onRatesEnterPressed('6', 'benchmark')}
												onChange={(text) => onRatesChanged('6', 'benchmark', text)}
											/>
											:
											<div style={{display: 'flex', flexDirection: 'row', position: 'relative', alignItems: 'center'}}>
												<p className={GeneralStyles.darkText}>{rates['6']['benchmark']}%</p>
												<Edit size={20} color={Colors.theme} style={{position: 'absolute', right: 0}} onClick={() => setCellSelected('r1c1')}/>
											</div>
									}

								</TableCell>
								<TableCell sx={{width: '20%'}}>
									{
										cellSelected === 'r1c2' ?
											<CustomTextFieldPlain
												value={rates['9']['benchmark']}
												enterPressed={() => onRatesEnterPressed('9', 'benchmark')}
												onChange={(text) => onRatesChanged('9', 'benchmark', text)}
											/>
											:
											<div style={{display: 'flex', flexDirection: 'row', position: 'relative', alignItems: 'center'}}>
												<p className={GeneralStyles.darkText}>{rates['9']['benchmark']}%</p>
												<Edit size={20} color={Colors.theme} style={{position: 'absolute', right: 0}} onClick={() => setCellSelected('r1c2')}/>
											</div>
									}
								</TableCell>
								<TableCell sx={{width: '20%'}}>
									{
										cellSelected === 'r1c3' ?
											<CustomTextFieldPlain
												value={rates['12']['benchmark']}
												enterPressed={() => onRatesEnterPressed('12', 'benchmark')}
												onChange={(text) => onRatesChanged('12', 'benchmark', text)}
											/>
											:
											<div style={{display: 'flex', flexDirection: 'row', position: 'relative', alignItems: 'center'}}>
												<p className={GeneralStyles.darkText}>{rates['12']['benchmark']}%</p>
												<Edit size={20} color={Colors.theme} style={{position: 'absolute', right: 0}} onClick={() => setCellSelected('r1c3')}/>
											</div>
									}
								</TableCell>
								<TableCell sx={{width: '20%'}}>
									{
										cellSelected === 'r1c4' ?
											<CustomTextFieldPlain
												value={rates['18']['benchmark']}
												enterPressed={() => onRatesEnterPressed('18', 'benchmark')}
												onChange={(text) => onRatesChanged('18', 'benchmark', text)}
											/>
											:
											<div style={{display: 'flex', flexDirection: 'row', position: 'relative', alignItems: 'center'}}>
												<p className={GeneralStyles.darkText}>{rates['18']['benchmark']}%</p>
												<Edit size={20} color={Colors.theme} style={{position: 'absolute', right: 0}} onClick={() => setCellSelected('r1c4')}/>
											</div>
									}
								</TableCell>
              </TableRow>

							<TableRow key={2}>
								<TableCell component="th" scope="row" sx={{width: '20%'}}>Spread</TableCell>
								<TableCell sx={{width: '20%'}}>
									{
										cellSelected === 'r2c1' ?
											<CustomTextFieldPlain
												value={rates['6']['spread']}
												enterPressed={() => onRatesEnterPressed('6', 'spread')}
												onChange={(text) => onRatesChanged('6', 'spread', text)}
											/>
											:
											<div style={{display: 'flex', flexDirection: 'row', position: 'relative', alignItems: 'center'}}>
												<p className={GeneralStyles.darkText}>{rates['6']['spread']}%</p>
												<Edit size={20} color={Colors.theme} style={{position: 'absolute', right: 0}} onClick={() => setCellSelected('r2c1')}/>
											</div>
									}
								</TableCell>
								<TableCell sx={{width: '20%'}}>
									{
										cellSelected === 'r2c2' ?
											<CustomTextFieldPlain
												value={rates['9']['spread']}
												enterPressed={() => onRatesEnterPressed('9', 'spread')}
												onChange={(text) => onRatesChanged('9', 'spread', text)}
											/>
											:
											<div style={{display: 'flex', flexDirection: 'row', position: 'relative', alignItems: 'center'}}>
												<p className={GeneralStyles.darkText}>{rates['9']['spread']}%</p>
												<Edit size={20} color={Colors.theme} style={{position: 'absolute', right: 0}} onClick={() => setCellSelected('r2c2')}/>
											</div>
									}
								</TableCell>
								<TableCell sx={{width: '20%'}}>
									{
										cellSelected === 'r2c3' ?
											<CustomTextFieldPlain
												value={rates['12']['spread']}
												enterPressed={() => onRatesEnterPressed('12', 'spread')}
												onChange={(text) => onRatesChanged('12', 'spread', text)}
											/>
											:
											<div style={{display: 'flex', flexDirection: 'row', position: 'relative', alignItems: 'center'}}>
												<p className={GeneralStyles.darkText}>{rates['12']['spread']}%</p>
												<Edit size={20} color={Colors.theme} style={{position: 'absolute', right: 0}} onClick={() => setCellSelected('r2c3')}/>
											</div>
									}
								</TableCell>
								<TableCell sx={{width: '20%'}}>
									{
										cellSelected === 'r2c4' ?
											<CustomTextFieldPlain
												value={rates['18']['spread']}
												enterPressed={() => onRatesEnterPressed('18', 'spread')}
												onChange={(text) => onRatesChanged('18', 'spread', text)}
											/>
											:
                        <div style={{display: 'flex', flexDirection: 'row', position: 'relative', alignItems: 'center'}}>
                            <p className={GeneralStyles.darkText}>{rates['18']['spread']}%</p>
                            <Edit size={20} color={Colors.theme} style={{position: 'absolute', right: 0}} onClick={() => setCellSelected('r2c4')}/>
                        </div>
									}
								</TableCell>
							</TableRow>

							<TableRow key={3}>
								<TableCell component="th" scope="row" sx={{width: '20%'}}>Tier 1 Rate (0%)</TableCell>
								<TableCell sx={{width: '20%'}}><p style={{color: Colors.primaryTextColor, fontSize: Constants.entryTextSize}}>{tier1.c1}%</p></TableCell>
								<TableCell sx={{width: '20%'}}><p style={{color: Colors.primaryTextColor, fontSize: Constants.entryTextSize}}>{tier1.c2}%</p></TableCell>
								<TableCell sx={{width: '20%'}}><p style={{color: Colors.primaryTextColor, fontSize: Constants.entryTextSize}}>{tier1.c3}%</p></TableCell>
								<TableCell sx={{width: '20%'}}><p style={{color: Colors.primaryTextColor, fontSize: Constants.entryTextSize}}>{tier1.c4}%</p></TableCell>
							</TableRow>

							<TableRow key={4}>
								<TableCell component="th" scope="row" sx={{width: '20%'}}>Tier 2 Rate (1%)</TableCell>
                  <TableCell sx={{width: '20%'}}><p style={{color: Colors.primaryTextColor, fontSize: Constants.entryTextSize}}>{tier2.c1}%</p></TableCell>
                  <TableCell sx={{width: '20%'}}><p style={{color: Colors.primaryTextColor, fontSize: Constants.entryTextSize}}>{tier2.c2}%</p></TableCell>
                  <TableCell sx={{width: '20%'}}><p style={{color: Colors.primaryTextColor, fontSize: Constants.entryTextSize}}>{tier2.c3}%</p></TableCell>
                  <TableCell sx={{width: '20%'}}><p style={{color: Colors.primaryTextColor, fontSize: Constants.entryTextSize}}>{tier2.c4}%</p></TableCell>
							</TableRow>

							{/*<TableRow key={5}>*/}
							{/*	<TableCell component="th" scope="row" sx={{width: '20%'}}>Tier 3 Rate (2%)</TableCell>*/}
              {/*    <TableCell sx={{width: '20%'}}><p style={{color: Colors.primaryTextColor, fontSize: Constants.entryTextSize}}>{tier3.c1}%</p></TableCell>*/}
              {/*    <TableCell sx={{width: '20%'}}><p style={{color: Colors.primaryTextColor, fontSize: Constants.entryTextSize}}>{tier3.c2}%</p></TableCell>*/}
              {/*    <TableCell sx={{width: '20%'}}><p style={{color: Colors.primaryTextColor, fontSize: Constants.entryTextSize}}>{tier3.c3}%</p></TableCell>*/}
              {/*    <TableCell sx={{width: '20%'}}><p style={{color: Colors.primaryTextColor, fontSize: Constants.entryTextSize}}>{tier3.c4}%</p></TableCell>*/}
							{/*</TableRow>*/}
						</TableBody>
					</Table>

					<div style={{width: '100%', position: 'relative', height: 50}}>
						<CustomButtonContained
							style={{height: 36, position: 'absolute', bottom: 0, right: 0}}
							text={`\u2713 Save Changes`}
							onClick={onSaveLoanRatesClicked}
						/>
					</div>
				</AccordionDetails>
			</Accordion>

		)
	}

	const renderUnderwritingValues = () => {
		return (
			<Accordion
        sx={{boxShadow: '0px 4px 15px 0px #00000066', border: '1px solid #E7E7E7', marginTop: 2}}
        expanded={expanded.includes(EXPANDABLE_VALUES[3])}
        onChange={() => handleExpandChange(EXPANDABLE_VALUES[3])}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{color: Colors.primaryTextColor}}/>}
          aria-controls="underwriting-content"
          id="underwriting-header"
          sx={{height: 40}}
        >
          <p className={GeneralStyles.darkText} style={{fontWeight: 'bold'}}>Underwriting Values</p>
        </AccordionSummary>
        <AccordionDetails>
          <div className={Styles.accordionDetails}>
						<CustomTextFieldNew
							width={'30%'}
							label={"Min DSCR (%)"}
							placeholder={'Enter Min DSCR Value'}
							value={dscr}
							onChange={(text) => {
								if (Helpers.checkIfNumber(text)) {
									setDscr(text)
								}
							}}
						/>

						<CustomTextFieldNew
							marginTop={10}
							width={'30%'}
							label={"Max CLTV (%)"}
							placeholder={'Enter Max CLTV Value'}
							value={cltv}
							onChange={(text) => {
								if (Helpers.checkIfNumber(text)) {
									setCltv(text)
								}
							}}
						/>

	          <CustomTextFieldNew
		          marginTop={10}
		          width={'30%'}
		          label={"Cap Rate (%)"}
		          placeholder={'Enter Cap Rate'}
		          value={capRate}
		          onChange={(text) => {
			          if (Helpers.checkIfNumber(text)) {
				          setCapRate(text)
			          }
		          }}
	          />

	          <div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
		          <CustomTextFieldNew
			          marginTop={10}
			          width={'14%'}
			          label={"Tier 1 DSCR"}
			          placeholder={'Enter DSCR Value'}
			          value={`${dscrTiers[0]}`}
			          onChange={(text) => {
				          if (Helpers.checkIfNumber(text)) {
					          let temp = [...dscrTiers]
					          temp[0] = text
					          setDscrTiers(temp)
				          }
			          }}
		          />
		          <CustomTextFieldNew
			          marginLeft={'1%'}
			          marginTop={10}
			          width={'14%'}
			          label={"Tier 2 DSCR"}
			          placeholder={'Enter DSCR Value'}
			          value={`${dscrTiers[1]}`}
			          onChange={(text) => {
				          if (Helpers.checkIfNumber(text)) {
					          let temp = [...dscrTiers]
					          temp[1] = text
					          setDscrTiers(temp)
				          }
			          }}
		          />
		          {/*<CustomTextFieldNew*/}
			        {/*  marginTop={10}*/}
			        {/*  width={'30%'}*/}
			        {/*  label={"Tier 3 DSCR"}*/}
			        {/*  placeholder={'Enter DSCR Value'}*/}
			        {/*  value={`${dscrTiers[2]}`}*/}
			        {/*  onChange={(text) => {*/}
				      {/*    if (!isNaN(text)) {*/}
					    {/*      let temp = [...dscrTiers]*/}
					    {/*      temp[2] = text*/}
					    {/*      setDscrTiers(temp)*/}
				      {/*    }*/}
			        {/*  }}*/}
		          {/*/>*/}
	          </div>


						<div style={{width: '100%', position: 'relative', height: 50}}>
							<CustomButtonContained
								style={{height: 36, position: 'absolute', bottom: 0, right: 0}}
								text={`\u2713 Save Changes`}
								onClick={onSaveUnderwritingValuesClicked}
							/>
						</div>

					</div>
				</AccordionDetails>
			</Accordion>
		)
	}

	const renderFinancialAssumptions = () => {
		return (
			<Accordion
				sx={{boxShadow: '0px 4px 15px 0px #00000066', border: '1px solid #E7E7E7', marginTop: 2}}
        expanded={expanded.includes(EXPANDABLE_VALUES[1])}
        onChange={() => handleExpandChange(EXPANDABLE_VALUES[1])}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{color: Colors.primaryTextColor}}/>}
          aria-controls="financials-content"
          id="financials-header"
          sx={{height: 40}}
        >
          <p className={GeneralStyles.darkText} style={{fontWeight: 'bold'}}>Financial Assumptions (% of Effective Rent)</p>
        </AccordionSummary>
        <AccordionDetails>
					<div className={Styles.accordionDetails}>
						<CustomTextFieldNew
							width={'30%'}
							label={"Vacancy Factor (%)"}
							placeholder={'Enter Vacancy Factor'}
							value={vacancy}
							onChange={(text) => {
								if (Helpers.checkIfNumber(text)) {
									setVacancy(text)
								}
							}}
						/>

						<CustomTextFieldNew
							marginTop={10}
							width={'30%'}
							label={"Property Taxes (%)"}
							placeholder={'Enter Property Taxes'}
							value={propertyTaxes}
							onChange={(text) => {
								if (Helpers.checkIfNumber(text)) {
									setPropertyTaxes(text)
								}
							}}
						/>

						<CustomTextFieldNew
              marginTop={10}
              width={'30%'}
              label={"Management Fees (%)"}
              placeholder={'Enter Management Fees'}
							value={managementFee}
							onChange={(text) => {
								if(Helpers.checkIfNumber(text))
									setManagementFee(text)
							}}
						/>

						<CustomTextFieldNew
							marginTop={10}
							width={'30%'}
							label={"Leasing Fees (%)"}
							placeholder={'Enter Leasing Fees'}
							value={leaseFee}
							onChange={(text) => {
								if(Helpers.checkIfNumber(text))
									setLeaseFee(text)
							}}
						/>

						<CustomTextFieldNew
							marginTop={10}
							width={'30%'}
							label={"Property Insurance (%)"}
							placeholder={'Enter Property Insurance'}
							value={insurance}
							onChange={(text) => {
								if(Helpers.checkIfNumber(text))
									setInsurance(text)
							}}
						/>

						<CustomTextFieldNew
							marginTop={10}
							width={'30%'}
							label={"Repairs & Maintenance (%)"}
							placeholder={'Enter Repairs & Maintenance Fees'}
							value={maintenance}
							onChange={(text) => {
								if(Helpers.checkIfNumber(text))
									setMaintenance(text)
							}}
						/>

						<CustomTextFieldNew
							marginTop={10}
							width={'30%'}
							label={"Cap Ex Reserve (%)"}
							placeholder={'Enter Cap Ex Reserve'}
							value={capEx}
							onChange={(text) => {
								if(Helpers.checkIfNumber(text))
									setCapEx(text)
							}}
						/>

						<CustomTextFieldNew
							marginTop={10}
							width={'30%'}
							label={"Other / Miscellaneous (%)"}
							placeholder={'Enter Misc. Fees (%)'}
							value={misc}
							onChange={(text) => {
								if(Helpers.checkIfNumber(text))
									setMisc(text)
							}}
						/>

						<CustomTextFieldNew
							marginTop={10}
							width={'30%'}
							label={"Turn Reserves (%)"}
							placeholder={'Enter Turn Reserves (%)'}
							value={turnReserves}
							onChange={(text) => {
								if(Helpers.checkIfNumber(text))
									setTurnReserves(text)
							}}
						/>

						<div style={{width: '100%', position: 'relative', height: 50}}>
							<CustomButtonContained
								style={{height: 36, position: 'absolute', bottom: 0, right: 0}}
								text={`\u2713 Save Changes`}
								onClick={onSaveFinancialsClicked}
							/>
						</div>

					</div>
				</AccordionDetails>
			</Accordion>
		)
	}


	const renderMortgageValues = () => {
		return (
			<Accordion
				sx={{boxShadow: '0px 4px 15px 0px #00000066', border: '1px solid #E7E7E7', marginTop: 2}}
				expanded={expanded.includes(EXPANDABLE_VALUES[0])}
				onChange={() => handleExpandChange(EXPANDABLE_VALUES[0])}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon style={{color: Colors.primaryTextColor}}/>}
					aria-controls="mortgage-content"
					id="mortgage-header"
					sx={{height: 40}}
				>
					<p className={GeneralStyles.darkText} style={{fontWeight: 'bold'}}>Mortgage Assumptions</p>
				</AccordionSummary>
				<AccordionDetails>
					<div className={Styles.accordionDetails}>
						<CustomTextFieldNew
							width={'30%'}
							label={"APR (%)"}
							placeholder={'Enter Annual Percentage Rate'}
							value={apr}
							onChange={(text) => {
								if (Helpers.checkIfNumber(text)) {
									setApr(text)
								}
							}}
						/>

						<CustomTextFieldNew
							marginTop={10}
							width={'30%'}
							label={"Loan to Cost (%)"}
							placeholder={'Enter Loan to Cost Value'}
							value={loanToCost}
							onChange={(text) => {
								if (Helpers.checkIfNumber(text)) {
									setLoanToCost(text)
								}
							}}
						/>

						<CustomTextFieldNew
							marginTop={10}
							width={'30%'}
							label={"Term (years)"}
							placeholder={'Enter Mortgage Term'}
							value={term}
							onChange={(text) => {
								if (Helpers.checkIfNumber(text)) {
									setTerm(text)
								}
							}}
						/>

						<div style={{width: '100%', position: 'relative', height: 50}}>
							<CustomButtonContained
								style={{height: 36, position: 'absolute', bottom: 0, right: 0}}
								text={`\u2713 Save Changes`}
								onClick={onSaveMortgageValuesClicked}
							/>
						</div>
					</div>
				</AccordionDetails>
			</Accordion>
		)
	}


	const renderContent = () => {
		return (
			<div>
				{renderMortgageValues()}
				{renderFinancialAssumptions()}
				{renderPricingAssumptions()}
				{renderUnderwritingValues()}
				{renderLoanTiers()}
			</div>
		)
	}


	return (
		<div className={GeneralStyles.container}>
			<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative' }}>
				<PageHeader header={'Settings'} />
				{/*<CustomButtonContained*/}
				{/*	text={'+ New Reservation'}*/}
				{/*	onClick={onNewReservationClicked}*/}
				{/*	style={{position: 'absolute', right: 40, zIndex: 10}}*/}
				{/*	color={showOverlay ? 'white' : 'primary'}*/}
				{/*/>*/}
			</div>

			<PositionedSnackbar
				onClose={() => {
					setShowError(false)
					setShowSuccess(false)
					setErrorMessage('')
					setSuccessMessage('')
				}}
				severity={showError ? 'error' : 'success'}
				openFlag={showError || showSuccess}
				message={showError ? errorMessage : successMessage}
			/>

			{
				loading ?
					<div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
						<CustomLoaderSpinner />
					</div>
					:
					renderContent()
			}
		</div>
	);
}
